import C from '../../../../utilities/constants'

const getCardBackgroundColor = (
  itemClosed: boolean | undefined,
  bidStatus: string | undefined
): string => {
  const {
    STATUS: { WON, WINNING, OUTBID, LOST, SOLD },
  } = C
  if (itemClosed || bidStatus === SOLD) return 'bg-gray-300 filter'
  if (bidStatus) {
    if ([OUTBID, LOST].includes(bidStatus)) return 'bg-losing'
    if ([WON, WINNING].includes(bidStatus)) return 'bg-winning'
  }
  return 'bg-white'
}

const getCardMiddleBorderColor = (
  itemClosed: boolean | undefined,
  bidStatus: string | undefined
): string => {
  const {
    STATUS: { WON, WINNING, OUTBID, LOST, SOLD },
  } = C
  if (itemClosed || bidStatus === SOLD) return 'border-gray'
  if (bidStatus) {
    if ([OUTBID, LOST].includes(bidStatus)) return 'border-bidfta-pink'
    if ([WON, WINNING].includes(bidStatus)) return 'border-bidfta-brightgreen'
  }
  return 'bg-white'
}

export { getCardBackgroundColor, getCardMiddleBorderColor }
